import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensServicesDeliveryProcedureSteps} from './citizens-services-delivery-procedure-steps.model';

export const loadCitizensServicesDeliveryProcedureStepss = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] Load CitizensServicesDeliveryProcedureStepss',
  props<{ citizensServicesDeliveryProcedureStepss: CitizensServicesDeliveryProcedureSteps[] }>()
);

export const addCitizensServicesDeliveryProcedureSteps = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] Add CitizensServicesDeliveryProcedureSteps',
  props<{ citizensServicesDeliveryProcedureSteps: CitizensServicesDeliveryProcedureSteps }>()
);

export const upsertCitizensServicesDeliveryProcedureSteps = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] Upsert CitizensServicesDeliveryProcedureSteps',
  props<{ citizensServicesDeliveryProcedureSteps: CitizensServicesDeliveryProcedureSteps }>()
);

export const addCitizensServicesDeliveryProcedureStepss = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] Add CitizensServicesDeliveryProcedureStepss',
  props<{ citizensServicesDeliveryProcedureStepss: CitizensServicesDeliveryProcedureSteps[] }>()
);

export const upsertCitizensServicesDeliveryProcedureStepss = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] Upsert CitizensServicesDeliveryProcedureStepss',
  props<{ citizensServicesDeliveryProcedureStepss: CitizensServicesDeliveryProcedureSteps[] }>()
);

export const updateCitizensServicesDeliveryProcedureSteps = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] Update CitizensServicesDeliveryProcedureSteps',
  props<{ citizensServicesDeliveryProcedureSteps: Update<CitizensServicesDeliveryProcedureSteps> }>()
);

export const updateCitizensServicesDeliveryProcedureStepss = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] Update CitizensServicesDeliveryProcedureStepss',
  props<{ citizensServicesDeliveryProcedureStepss: Update<CitizensServicesDeliveryProcedureSteps>[] }>()
);

export const deleteCitizensServicesDeliveryProcedureSteps = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] Delete CitizensServicesDeliveryProcedureSteps',
  props<{ id: string }>()
);

export const deleteCitizensServicesDeliveryProcedureStepss = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] Delete CitizensServicesDeliveryProcedureStepss',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesDeliveryProcedureStepss = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] Clear CitizensServicesDeliveryProcedureStepss'
);



//CUSTOMS

export const citizenGetServicesDeliveryProcedureSteps = createAction(
  '[CitizensServicesDeliveryProcedureSteps/API] citizen Get Services Delivery Procedure Steps',
  props<{ serviceUniqueId: string }>()
);

